import { Group } from '../../models';
import {
    GROUPS_LOAD_SUCCESS,
    GROUPS_LOAD,
    GROUP_ADD_SUCCESS,
    GROUP_DUPLICATE,
    GROUP_DUPLICATE_SUCCESS,
    GROUP_DUPLICATE_ERROR,
    GROUP_LOAD_SUCCESS,
    GROUP_LOAD,
    GROUP_ADD,
    GROUP_UPDATE_SUCCESS,
    GROUP_ADD_ERROR,
    GROUP_UPDATE_ERROR
} from './groups.constants';

export function addGroup() {
    return { type: GROUP_ADD };
}

export function addGroupSuccess(createdGroup?: Group) {
    return { type: GROUP_ADD_SUCCESS, payload: createdGroup };
}

export function addGroupError() {
    return { type: GROUP_ADD_ERROR };
}

export function updateGroup() {
    return { type: GROUP_ADD };
}

export function updateGroupSuccess(createdGroup?: Group) {
    return { type: GROUP_UPDATE_SUCCESS, payload: createdGroup };
}

export function updateGroupError() {
    return { type: GROUP_UPDATE_ERROR };
}

export function loadGroup() {
    return { type: GROUP_LOAD };
}

export function loadGroupSuccess(data: Group) {
    return { type: GROUP_LOAD_SUCCESS, payload: { group: data } };
}

export function loadGroups() {
    return { type: GROUPS_LOAD };
}

export function loadGroupsSuccess(data: Group[]) {
    return { type: GROUPS_LOAD_SUCCESS, payload: data };
}

export function duplicateGroup() {
    return { type: GROUP_DUPLICATE };
}

export function duplicateGroupSuccess(data: Group[]) {
    return { type: GROUP_DUPLICATE_SUCCESS, payload: data };
}

export function duplicateGroupError(reason: any) {
    return { type: GROUP_DUPLICATE_ERROR, payload: reason };
}